export default __webpack_public_path__ + "static/media/sc39.85a8a1a0.jpg";